module.exports = __webpack_public_path__ + "img/agro_tampa_dosadora_1000ml.b1648856.png";